import React, { useState } from 'react';

const ContactFormSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: '',
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);  // Add isSubmitting state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = 'Name is required.';
    if (!formData.email) {
      newErrors.email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email address is invalid.';
    }
    if (!formData.company) newErrors.company = 'Company name is required.';
    if (!formData.message) newErrors.message = 'Message is required.';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setIsSubmitting(true);  // Start submitting
      try {
        const response = await fetch('http://localhost:5000/submit', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const result = await response.json();
        console.log('Form data submitted successfully:', result);
        setSuccessMessage('Your inquiry has been submitted.');
        setErrorMessage('');
        setIsSubmitting(false);  // Stop submitting

        // Reset form after submission
        setFormData({ name: '', email: '', company: '', message: '' });
        setErrors({});
      } catch (error) {
        console.error('Form submission error:', error);
        setErrorMessage('Your inquiry could not be submitted.');
        setSuccessMessage('');
        setIsSubmitting(false);  // Stop submitting
      }
    }
  };

  return (
    <section className="section-003cnt section-003ab">
      <div className="container">
        <div className="inner-content">
          <div className="left-wrapper">
            <div className="form-wrapper">
              <div className="content-wrap">
                <h4><span>Reach Out to</span> Us</h4>
                <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                  {errors.name && <span className="error">{errors.name}</span>}
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  {errors.email && <span className="error">{errors.email}</span>}
                  <input
                    type="text"
                    name="company"
                    placeholder="Company Name"
                    value={formData.company}
                    onChange={handleChange}
                    required
                  />
                  {errors.company && <span className="error">{errors.company}</span>}
                  <textarea
                    rows="4"
                    cols="10"
                    name="message"
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                  {errors.message && <span className="error">{errors.message}</span>}
                  <div className="dft-btn">
                    <button type="submit" className="btn" disabled={isSubmitting}>
                      {isSubmitting ? 'Sending...' : 'Submit'} {/* Change button text */}
                    </button>
                  </div>
                </form>
                {successMessage && <p className="success">{successMessage}</p>}
                {errorMessage && <p className="error">{errorMessage}</p>}
              </div>
            </div>
          </div>
          <div className="right-wrapper">
            <h4>Message <span>Our</span></h4>
            <p>
            If you would like more information about our services or would like to discuss a project, we are here to help.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactFormSection;
